import React, { useEffect, useState } from "react";
import { ReactComponent as LockLogo } from "../../Assets/Auth/ForgotPassword/ForgotIcon.svg";
import { ReactComponent as EmailLogo } from "../../Assets/Auth/Email.svg";
import { forgotPass } from "../../Redux/Actions/authActions";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors } from "../../Redux/Actions/authActions";
import CustomAlert from "../../Components/Other/alert";
import OrgLogo from "../../Components/Other/logo";

const ForgotPass = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {error,success, message} = useSelector(state => state.forgotPass);

  const handleForgot = (e) => {
    dispatch(forgotPass(email));
  };

  const handleNavigate = (e) => {
    e.preventDefault();
    navigate(-1);
  }

  useEffect(() => {
    document.title = "Forgot Password";

    if (error) {
          setErrorMessage(error.data.message);
          dispatch(clearErrors());
        }

    if(errorMessage){
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    }

    if(success === true){
      navigate("/reset-password");
      dispatch({type: "PASS_RESET"});
    }

    if(message){
        console.log(message);
    }
  }, [message, dispatch, success, error, navigate, errorMessage])

  return (
    <div className="login-container flex-container flex-center">
      <OrgLogo />
      <div className="mid-container mirror-container">
        <div className="login-form flex-container flex-center flex-column">
          <div className="login-icon-container">
            <LockLogo className="login-icon" />
          </div>
          <div className="login-title">
            <h2>Forgot your Password?</h2>
            <p>Enter your email address to reset your password</p>
          </div>
          <div className="login-input flex-container flex-row">
            <div className="login-input-icon-container">
              <EmailLogo className="login-input-icon" />
            </div>
            <input
              type="email"
              value={email}
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="login-forgot">
            <Link onClick={handleNavigate}>Return to sign in screen</Link>
          </div>
          <div className="login-button width-100">
            <button
              onClick={handleForgot}
              className="width-100 alt-black font-white font-SemiBold border-15"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
      <CustomAlert errorMessage = {errorMessage ? errorMessage : ''} />
      <div>
      </div>
    </div>
  );
};

export default ForgotPass;
